import InfoIcon from "@material-ui/icons/Info";
import { IRoute } from "src/common/typings/routes";
import { Main } from "./Main";
import { Unauthorized } from "./pages/Unauthorized";

export const UnauthorizedRoute: IRoute = {
  title: "Unauthorized",
  path: "/unauthorized",
  component: Main,
  // guard: true,
  subRoutes: [
    { icon: InfoIcon, component: Unauthorized, path: "/unauthorized", title: "Unauthorized" },
  ],
};
